import { defaultsConfig } from "~config/sport/defaults";
import { PeriodTypes } from "~enums/periodTypes.ts";
import { Roles } from "~enums/roles";
import { RosterPosition } from "~enums/rosterPosition";
import { UniformItemBottomTypes } from "~enums/uniformItemBottomTypes";
import { UniformItemColors } from "~enums/uniformItemColors";
import { UniformItemTopTypes } from "~enums/uniformItemTopTypes";
import { UniformItemTypes } from "~enums/uniformItemTypes";
import type { SportConfiguration } from "~types/sportConfiguration";
import { basketballUiConfig } from "./basketballUi";

const seasonOfficialRoles: Array<Roles> = [
  Roles.CrewChief,
  Roles.Groundskeeper,
  Roles.Referee,
  Roles.RefereeAssistant,
  Roles.RefereeAssistantReserve,
  Roles.RefereeReserve,
  Roles.Scorer,
  Roles.ScorerAssistant,
  Roles.ShotClockOperator,
  Roles.Statistician,
  Roles.Timer,
  Roles.Umpire,
  Roles.Umpire1,
  Roles.Umpire2,
  Roles.Commissioner,
  Roles.Committee,
  Roles.General,
  Roles.President,
  Roles.PresidentVice,
  Roles.Treasurer,
];

const fixtureOfficialRoles: Array<Roles> = [...seasonOfficialRoles];

const rosterPositions: Array<RosterPosition> = [
  RosterPosition.Center,
  RosterPosition.Forward,
  RosterPosition.ForwardCenter,
  RosterPosition.Guard,
  RosterPosition.GuardForward,
  RosterPosition.PowerForward,
  RosterPosition.PointGuard,
  RosterPosition.SmallForward,
  RosterPosition.ShootingGuard,
];

const uniforms: SportConfiguration["uniforms"] = {
  bottomOptions: [UniformItemBottomTypes.Shorts],
  items: [
    {
      titleIntlKey: "uniform.regular",
      topType: [UniformItemTopTypes.Sleeveless],
      itemTypes: {
        [UniformItemTypes.Top]: [UniformItemColors.Primary],
        [UniformItemTypes.Bottom]: [UniformItemColors.Primary],
      },
    },
    {
      titleIntlKey: "uniform.warmUp",
      topType: [UniformItemTopTypes.LongSleeve, UniformItemTopTypes.ShortSleeve],
      itemTypes: {
        [UniformItemTypes.WarmUpTop]: [UniformItemColors.Primary, UniformItemColors.Secondary],
      },
    },
  ],
};

export const basketballConfig: SportConfiguration = {
  ...defaultsConfig,
  seasonOfficialRoles,
  fixtureOfficialRoles,
  uniforms,
  rosterPositions,
  uiConfiguration: basketballUiConfig,
  periods: {
    [PeriodTypes.Period1]: { intlKey: "period.period1" },
    [PeriodTypes.Period2]: { intlKey: "period.period2" },
    [PeriodTypes.Period3]: { intlKey: "period.period3" },
    [PeriodTypes.Period4]: { intlKey: "period.period4" },
    [PeriodTypes.ExtraPeriod1]: { intlKey: "period.overtime1" },
    [PeriodTypes.ExtraPeriod2]: { intlKey: "period.overtime2" },
    [PeriodTypes.ExtraPeriod3]: { intlKey: "period.overtime3" },
    [PeriodTypes.ExtraPeriod4]: { intlKey: "period.overtime4" },
    [PeriodTypes.ExtraPeriod5]: { intlKey: "period.overtime5" },
    [PeriodTypes.ExtraPeriod6]: { intlKey: "period.overtime6" },
  },
};
